import { useEffect } from "react";
import { injectIntl } from "react-intl";
import { Backdrop, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import { USER_NOT_AUTHENTICATED_LABEL, ACCEDI_LABEL } from "../../modules/language";
import { getMessageString } from "../../utility";
import packageJson from "../../../package.json";
import { useDispatch, useSelector } from "react-redux";
import { fetchSessionInfo, getSessionTime } from "../../modules/common";

export const UserNotAuthenticated = injectIntl(({ intl, open }) => {
  const dispatch = useDispatch();
  const sessionTime = useSelector(getSessionTime);

  useEffect(() => {
    if (!sessionTime) dispatch(fetchSessionInfo());
    // eslint-disable-next-line
  }, [sessionTime]);

  return (
    <Backdrop sx={{ color: "#fff" }} open={open} className="userNotAuthenticated">
      <Card>
        <CardContent>
          <Stack>
            <Button
              startIcon={<PersonIcon />}
              onClick={() => (window.location.href = window.origin + "/auth/loginUser?postLoginUriCustom=/" + packageJson.homepage)}
            >
              {getMessageString(intl, ACCEDI_LABEL)}
            </Button>
            <Typography variant="h2">
              {intl.formatMessage(
                {
                  id: USER_NOT_AUTHENTICATED_LABEL,
                  defaultMessage: USER_NOT_AUTHENTICATED_LABEL,
                },
                { durata: parseInt(sessionTime / 60) }
              )}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Backdrop>
  );
});
